module.exports = __webpack_public_path__ + "img/20230525155057937w82.9052b3fc.jpg";